/* eslint-disable max-len */
var UI_MINUS = {
  "default": 'M32,16a1.25,1.25,0,0,1-1.25,1.25H1.25a1.25,1.25,0,0,1,0-2.5h29.5A1.25,1.25,0,0,1,32,16Z',
  globetrotter: 'M2.5 16H29.5'
};

export { UI_MINUS };
//# sourceMappingURL=UI_MINUS.js.map
